import { render } from "./ChipInput.vue?vue&type=template&id=006a2d0a"
import script from "./ChipInput.vue?vue&type=script&lang=js"
export * from "./ChipInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Components/ChipInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "006a2d0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('006a2d0a', __exports__)) {
    api.reload('006a2d0a', __exports__)
  }
  
  module.hot.accept("./ChipInput.vue?vue&type=template&id=006a2d0a", () => {
    api.rerender('006a2d0a', render)
  })

}


export default __exports__